import {
  Banknote,
  Bell,
  BookOpen,
  Building2,
  Calculator,
  Calendar,
  CalendarClock,
  CalendarDays,
  ClipboardCheck,
  Database,
  FileText,
  GitCommit,
  GraduationCap,
  Handshake,
  History,
  Image,
  Layers,
  LayoutDashboard,
  LayoutTemplate,
  Link2,
  ListTree,
  Menu,
  MessageSquare,
  Percent,
  PieChart,
  Receipt,
  Scale,
  School,
  Send,
  Settings,
  Settings2,
  ShieldCheck,
  Tag,
  UserCheck,
  UserCog,
  Users,
  UsersRound,
  Wallet,
} from 'lucide-react'
import type { LucideIcon } from 'lucide-react'

/** Maps the `icon` string stored on a menu record to a real component. */
export const ICON_MAP: Record<string, LucideIcon> = {
  Banknote,
  Bell,
  BookOpen,
  Building2,
  Calculator,
  Calendar,
  CalendarClock,
  CalendarDays,
  ClipboardCheck,
  Database,
  FileText,
  GitCommit,
  GraduationCap,
  Handshake,
  History,
  Image,
  Layers,
  LayoutDashboard,
  LayoutTemplate,
  Link2,
  ListTree,
  Menu,
  MessageSquare,
  Percent,
  PieChart,
  Receipt,
  Scale,
  School,
  Send,
  Settings,
  Settings2,
  ShieldCheck,
  Tag,
  UserCheck,
  UserCog,
  Users,
  UsersRound,
  Wallet,
}

export const DefaultIcon = Layers

export function iconFor(name: string | null | undefined): LucideIcon {
  return (name && ICON_MAP[name]) || DefaultIcon
}
